import { render, staticRenderFns } from "./PhenologicalTrackingWorkflowForm.vue?vue&type=template&id=0139b062&scoped=true&lang=html&"
import script from "./PhenologicalTrackingWorkflowForm.vue?vue&type=script&lang=js&"
export * from "./PhenologicalTrackingWorkflowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0139b062",
  null
  
)

export default component.exports